import TablePlainDataCell from './TablePlainDataCell';

interface TableTextCell {
    label?: string | number | undefined;
    dataLabel: string | number | undefined;
}

export default ({ dataLabel, label }: TableTextCell) => {
    return (
        <TablePlainDataCell dataLabel={dataLabel}>
            <p className="text-gray-900 whitespace-no-wrap text-base">{label}</p>
        </TablePlainDataCell>
    );
};
